/**
 * Camarotev2 Vue.js Application
 * Components v2 based on riocarnaval.org
 */

import Vue from 'vue';
import VueTinySlider from 'vue-tiny-slider';
import axios from 'axios';
import svg from './svg';

// Setup axios globally
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';

// SVG helper function
Vue.prototype.svg = svg;

// Import general components
import Splash from './components/general/Splash.vue';
import Faq from './components/general/Faq.vue';
import FaqItem from './components/general/FaqItem.vue';
import Collapse from './components/general/Collapse.vue';
import VideoGallery from './components/general/VideoGallery.vue';
import VideoResponsive from './components/general/VideoResponsive.vue';
import Toast from './components/general/Toast.vue';
import ContactOptions from './components/general/ContactOptions.vue';
import SliderCircle from './components/general/SliderCircle.vue';
import Mosaic from './components/general/Mosaic.vue';
import CarnivalCountdown from './components/general/CarnivalCountdown.vue';
import GuideCounter from './components/general/GuideCounter.vue';
import SvgIcon from './components/general/SvgIcon.vue';
import ScrollIndicator from './components/general/ScrollIndicator.vue';
import HighlightBase from './components/general/HighlightBase.vue';

// Import camarote components
import AttractionsTabCards from './components/camarote/AttractionsTabCards.vue';
import Rating from './components/camarote/Rating.vue';

// Import modal components
import ModalTarget from './components/modal/ModalTarget.vue';

// Import form components
import ContactForm from './components/form/ContactForm.vue';
import NewsletterForm from './components/form/NewsletterForm.vue';
import NewsletterFooterForm from './components/form/NewsletterFooterForm.vue';
import SelectForm from './components/form/SelectForm.vue';
import MultiSelectForm from './components/form/MultiSelectForm.vue';
import ClubBookersV2Form from './components/form/ClubBookersV2Form.vue';
import GuideForm from './components/form/GuideForm.vue';

// Import ticket components
import TicketsTable from './components/tickets/TicketsTable.vue';
import TicketsTableBody from './components/tickets/TicketsTableBody.vue';
import TicketsTableHead from './components/tickets/TicketsTableHead.vue';
import TicketsTablePrice from './components/tickets/TicketsTablePrice.vue';
import TicketsTableSubmit from './components/tickets/TicketsTableSubmit.vue';
import TicketsTableInformation from './components/tickets/TicketsTableInformation.vue';
import TicketsTableLocationTab from './components/tickets/TicketsTableLocationTab.vue';
import TicketsTableTooltip from './components/tickets/TicketsTableTooltip.vue';
import MobileTicketsTable from './components/tickets/MobileTicketsTable.vue';
import MobileTicketsItem from './components/tickets/MobileTicketsItem.vue';
import MobileTicketsFilter from './components/tickets/MobileTicketsFilter.vue';
import TicketsSplash from './components/tickets/TicketsSplash.vue';
import TicketsPromocode from './components/tickets/TicketsPromocode.vue';
import TicketsPromotionalBanner from './components/tickets/TicketsPromotionalBanner.vue';
import TicketsDeliveryOptions from './components/tickets/TicketsDeliveryOptions.vue';
import TicketsKokoTips from './components/tickets/TicketsKokoTips.vue';
import TicketsPaymentInfoCards from './components/tickets/TicketsPaymentInfoCards.vue';
import SambadromeMap from './components/tickets/SambadromeMap.vue';

// Import map components
import MapSambadrome from './components/map/MapSambadrome.vue';

// Import ticket packages components
import TicketPackages from './components/packages/tickets/TicketPackages.vue';
import TicketPackageDetails from './components/packages/tickets/TicketPackageDetails.vue';
import TicketPackageGallery from './components/packages/tickets/TicketPackageGallery.vue';
import TicketPackagesList from './components/packages/tickets/TicketPackagesList.vue';
import TicketPackagesListItem from './components/packages/tickets/TicketPackagesListItem.vue';
import TicketPackagesFilter from './components/packages/tickets/TicketPackagesFilter.vue';
import TicketPackagesFilterMap from './components/packages/tickets/TicketPackagesFilterMap.vue';
import TicketPackagesFilterDrawer from './components/packages/tickets/TicketPackagesFilterDrawer.vue';
import TicketPackagesFlag from './components/packages/tickets/TicketPackagesFlag.vue';
import TicketPackagesHeader from './components/packages/tickets/TicketPackagesHeader.vue';
import TicketPackagesPrice from './components/packages/tickets/TicketPackagesPrice.vue';
import TicketPackagesResumeBar from './components/packages/tickets/TicketPackagesResumeBar.vue';
import TicketPackagesType from './components/packages/tickets/TicketPackagesType.vue';
import CartResumeBarWidget from './components/packages/tickets/CartResumeBarWidget.vue';

// Create global event bus
window.eventBus = new Vue();

// Register tiny-slider component
Vue.component('tiny-slider', VueTinySlider);

// Register general components globally
Vue.component('splash', Splash);
Vue.component('faq', Faq);
Vue.component('faq-item', FaqItem);
Vue.component('collapse', Collapse);
Vue.component('video-gallery', VideoGallery);
Vue.component('video-responsive', VideoResponsive);
Vue.component('toast', Toast);
Vue.component('contact-options', ContactOptions);
Vue.component('slider-circle', SliderCircle);
Vue.component('mosaic', Mosaic);
Vue.component('carnival-countdown', CarnivalCountdown);
Vue.component('guide-counter', GuideCounter);
Vue.component('svg-icon', SvgIcon);
Vue.component('scroll-indicator', ScrollIndicator);
Vue.component('highlight-base', HighlightBase);
Vue.component('modal-target', ModalTarget);

// Register camarote components globally
Vue.component('attractions-tab-cards', AttractionsTabCards);
Vue.component('rating', Rating);

// Register form components globally
Vue.component('contact-form', ContactForm);
Vue.component('newsletter-form', NewsletterForm);
Vue.component('newsletter-form-simple', NewsletterForm);
Vue.component('newsletter-footer-form', NewsletterFooterForm);
Vue.component('select-form', SelectForm);
Vue.component('multi-select-form', MultiSelectForm);
Vue.component('club-bookers-v2-form', ClubBookersV2Form);
Vue.component('guide-form', GuideForm);

// Register ticket components globally
Vue.component('tickets-table', TicketsTable);
Vue.component('TicketsTableBody', TicketsTableBody);
Vue.component('TicketsTableHead', TicketsTableHead);
Vue.component('TicketsTablePrice', TicketsTablePrice);
Vue.component('TicketsTableSubmit', TicketsTableSubmit);
Vue.component('TicketsTableInformation', TicketsTableInformation);
Vue.component('TicketsTableLocationTab', TicketsTableLocationTab);
Vue.component('TicketsTableTooltip', TicketsTableTooltip);
Vue.component('mobile-tickets-table', MobileTicketsTable);
Vue.component('MobileTicketsItem', MobileTicketsItem);
Vue.component('MobileTicketsFilter', MobileTicketsFilter);
Vue.component('TicketsSplash', TicketsSplash);
Vue.component('TicketsPromocode', TicketsPromocode);
Vue.component('TicketsPromotionalBanner', TicketsPromotionalBanner);
Vue.component('TicketsDeliveryOptions', TicketsDeliveryOptions);
Vue.component('TicketsKokoTips', TicketsKokoTips);
Vue.component('TicketsPaymentInfoCards', TicketsPaymentInfoCards);
Vue.component('sambadrome-map', SambadromeMap);
Vue.component('map-sambadrome', MapSambadrome);

// Register ticket packages components globally
Vue.component('ticket-packages', TicketPackages);
Vue.component('TicketPackageDetails', TicketPackageDetails);
Vue.component('TicketPackageGallery', TicketPackageGallery);
Vue.component('TicketPackagesList', TicketPackagesList);
Vue.component('TicketPackagesListItem', TicketPackagesListItem);
Vue.component('TicketPackagesFilter', TicketPackagesFilter);
Vue.component('TicketPackagesFilterMap', TicketPackagesFilterMap);
Vue.component('TicketPackagesFilterDrawer', TicketPackagesFilterDrawer);
Vue.component('TicketPackagesFlag', TicketPackagesFlag);
Vue.component('TicketPackagesHeader', TicketPackagesHeader);
Vue.component('TicketPackagesPrice', TicketPackagesPrice);
Vue.component('TicketPackagesResumeBar', TicketPackagesResumeBar);
Vue.component('TicketPackagesType', TicketPackagesType);
Vue.component('CartResumeBarWidget', CartResumeBarWidget);

import './toast';

// Initialize Vue app
const app = new Vue({
    el: '#app',
    data: {
        modal: {
            koko: false,
            simple: false
        }
    },
    methods: {
        toggleModal(name = 'simple') {
            document.body.classList.toggle('modal');
            this.modal[name] = !this.modal[name];
        }
    }
});

// A barra de resumo do carrinho (cart-resume-bar-widget) é montada numa
// instância Vue separada porque a topbar (_topbar_credentials.blade.php)
// é renderizada fora da árvore de #app nos 4 domínios v2.
if (document.getElementById('cart-resume-bar-root')) {
    new Vue({
        el: '#cart-resume-bar-root'
    });
}

export default app;
